import clsx from "clsx";
import Spinner from "@/components/Spinner";
import { BackIcon } from "@/components/RFIcon";
import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers } from "@/interfaces/enums";

export interface Option {
	label: string;
	value: string | number;
	id?: string;
}

interface Props {
	value?: string | number;
	loading?: boolean;
	options: Option[];
	onChange: (value: string | number) => void;
}

interface OptionCardProps extends Option {
	selected: boolean;
	loading?: boolean;
	onClick: (value: string | number) => void;
}

export default function SelectOptions(props: Props) {
	if (props.options.length === 0) {
		return null;
	}

	return (
		<>
			{props.options.map((option, index) => {
				return (
					<OptionCard
						key={option.id || String(index)}
						label={option.label}
						value={option.value}
						selected={option.value === props.value}
						loading={props.loading}
						onClick={() => {
							props.onChange(option.value);
							bridge.call(BridgeCallHandlers.ON_INVOKE_HAPTIC_ENGINE, {
								key: "style",
								value: "rigid",
							});
						}}
					/>
				);
			})}
		</>
	);
}

function OptionCard(props: OptionCardProps) {
	return (
		<div className={clsx("pl-4.5", props.selected ? "bg-f6f7f9 dark:bg-white dark:text-dark" : "")}>
			<a
				className={clsx(
					"flex items-center justify-between py-4 pr-4.5",
					props.selected ? "border-b-1 border-b-transparent" : "f2_19_bottom",
				)}
				id={props.id}
				onClick={() => props.onClick(props.value)}
			>
				<span className={clsx("mr-4 flex-1 text-sm font-semibold")}>{props.label}</span>

				{props.loading && props.selected ? (
					<Spinner size="sm" />
				) : (
					<BackIcon className={clsx("w-5 h-5 -rotate-180", props.selected ? "text-dark" : "c3_53_text")} />
				)}
			</a>
		</div>
	);
}
